const container = ['flex', 'justify-center', 'items-center', 'h-screen'].join(' ');

export { container };
